module.exports = __webpack_public_path__ + "img/lynnpass.2a382893.png";